import { EPromoType } from '../types/newbuilding/promoInfo';

export const MORTGAGE_PROMO_TYPES = [EPromoType.Mortgage, EPromoType.Bank, EPromoType.CianMortgage];
